import React from 'react';
const EditReportModalBody = ({
  onReportEditSubmit,
  onReportEditModalToggle,
  reportComment,
  onReportCommentChange,
  isReportErrorMessageDisplay = false,
  reportErrorMessage = '',
}) => {
  return (
    <div className='card-block'>
      <form>
        <div className='row'>
          <div className='col-sm-12 margin_bottom_10'>
            <textarea
              id='comment'
              name='reportComment'
              rows='6'
              className='form-control'
              placeholder='Content..'
              onChange={event => onReportCommentChange(event)}
              value={reportComment}
            />
            <span className={`${!isReportErrorMessageDisplay ? 'd-none' : 'd-block'} text-danger`}>
              {reportErrorMessage}
            </span>
          </div>
        </div>
        <div className='row'>
          <div className='col-sm-12 d-flex'>
            <button
              onClick={event => onReportEditSubmit(event)}
              className='btn btn-primary active pointer_class'
            >
              Update
            </button>
            <button
              type='button'
              className='btn btn-danger active pointer_class margin_left_10'
              onClick={() => onReportEditModalToggle()}
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
export default EditReportModalBody;



// WEBPACK FOOTER //
// ./src/Components-2025/dashboard/EditReportModalBody.jsx